import { stringifyGraph } from '@/clients/http'
import { DeliveryLocationTypeModel } from '@/http/models/DeliveryLocationType'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import {
  DeliveryLocationTypeHttpParams,
  DeliveryLocationTypeModel as DeliveryLocationTypeType,
} from '@/types'

export interface DeliveryLocationTypeListFilters {
  search?: string
}

export interface DeliveryLocationTypeListForm extends UseFetchListForm<
  DeliveryLocationTypeListFilters,
  DeliveryLocationTypeType.DeliveryLocationType
> {}

interface UseFetchDeliveryLocationTypesProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const deliveryLocationTypeInitialFilters: DeliveryLocationTypeListFilters = {
  search: '',
}

export const useFetchDeliveryLocationTypes = ({
  sort,
  shouldFetchList,
}: UseFetchDeliveryLocationTypesProps) => {
  return useFetchList<
    DeliveryLocationTypeListFilters,
    DeliveryLocationTypeType.DeliveryLocationType,
    {},
    any,
    typeof DeliveryLocationTypeModel.getList
  >({
    pageSize: 10,
    initialFilters: deliveryLocationTypeInitialFilters,
    fetchFunction: DeliveryLocationTypeModel.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<DeliveryLocationTypeHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        'orders.count': true,
      }),
    }),
    buildParams: () => ({}),
  })
}
